import React from 'react';
import useRefreshToken from 'hooks/useRefreshToken';
import useInitSocket, { SocketContext } from 'hooks/useSocket';
import { Route, Routes } from 'react-router-dom';
import NotFoundPage from './NotFound';
import RefreshPage from './RefreshPage';
import ShopWrapperLayout from './ShopWrapperLayout';
import { APPOINTMENT_LAYOUT } from './appointment/services/constants';

const AppointmentsPage = React.lazy(() => import('./appointment/pages/AppointmentsPage'));
const AppointmentDetail = React.lazy(() => import('./appointment/pages/AppointmentDetail'));
const LoginPage = React.lazy(() => import('./auth/pages/Login'));
const OwnerDashboard = React.lazy(() => import('./auth/pages/OwnerDashboard'));
const CustomerDetails = React.lazy(() => import('./customer/pages/CustomerDetails'));
const EditCustomers = React.lazy(() => import('./customer/pages/EditCustomer'));
const ListCustomerPage = React.lazy(() => import('./customer/pages/ListCustomerPage'));
const SettingServicePage = React.lazy(() => import('./settingService/pages/SettingPage'));
const AddStaff = React.lazy(() => import('./settingStaff/pages/AddStaff'));
const SettingStaffList = React.lazy(() => import('./settingStaff/pages/SettingStaffList'));
const SettingStaffPage = React.lazy(() => import('./settingStaff/pages/SettingStaffPage'));
const StoryboardPage = React.lazy(() => import('./storyboard'));

const RootScreens = () => {
  const { shield } = useRefreshToken();
  const socketContext = useInitSocket();

  return (
    <SocketContext.Provider value={socketContext}>
      <>
        <Routes>
          <Route path="refresh" element={<RefreshPage />} />
          <Route path="store/:shop_id" element={shield(ShopWrapperLayout)}>
            <Route path="" element={<AppointmentsPage layout={APPOINTMENT_LAYOUT.CALENDAR} />} />
            <Route path="list-view" element={<AppointmentsPage layout={APPOINTMENT_LAYOUT.LIST} />} />
            <Route
              path="appointments/:appointment_id"
              element={<AppointmentDetail />}
            />
            <Route path="setting-service">
              <Route path="" element={<SettingServicePage />} />
              <Route path=":tab" element={<SettingServicePage />} />
            </Route>

            <Route path="setting-staff">
              <Route path="" element={<SettingStaffList />} />
              <Route path=":tab" element={<SettingStaffPage />} />
              <Route path="add-new" element={<AddStaff />} />
            </Route>

            <Route path="customers" element={<ListCustomerPage />} />
            <Route path="customers/:id">
              <Route path="" element={<CustomerDetails />} />
              <Route path="edit" element={<EditCustomers />} />
            </Route>
          </Route>
          <Route path="/sign-in" element={<LoginPage />} />
          <Route path="/owner/dashboard" element={shield(OwnerDashboard)} />
          <Route path="/" element={<LoginPage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/dev/storyboard" element={<StoryboardPage />} />
        </Routes>
      </>
    </SocketContext.Provider>
  );
};

export default RootScreens;
